import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type RescheduleEventMutationVariables = Types.Exact<{
  orgId: Types.Scalars["String"];
  externalEventId: Types.Scalars["String"];
  type: Types.EventTimeType;
  dateOrDateTime: Types.Scalars["String"];
  timeZone?: Types.InputMaybe<Types.Scalars["String"]>;
  offsetMinutes?: Types.InputMaybe<Types.Scalars["Float"]>;
  millis: Types.Scalars["Float"];
}>;

export type RescheduleEventMutation = {
  __typename: "Mutation";
  rescheduleEventParent: {
    __typename: "RescheduleEventParentMutationPayload";
    eventParent: {
      __typename: "EventParent";
      events: Array<{
        __typename: "Event";
        startTime: { __typename: "EventTime"; millis: number };
        endTime: { __typename: "EventTime"; millis: number };
        annotatedEvent: {
          __typename: "AnnotatedEvent";
          id: string;
          externalEventId: string | null;
          orgTags: Array<{
            __typename: "OrgTag";
            tag: string;
            state: {
              __typename: "TagState";
              value: string | null;
              subjectType: Types.SubjectUrnTypeEnum;
              subjectValue: string;
              lastModified: number;
              active: boolean;
            };
          }> | null;
        } | null;
        annotatedRecurringEvent: {
          __typename: "AnnotatedEvent";
          id: string;
          externalEventId: string | null;
          orgTags: Array<{
            __typename: "OrgTag";
            tag: string;
            state: {
              __typename: "TagState";
              value: string | null;
              subjectType: Types.SubjectUrnTypeEnum;
              subjectValue: string;
              lastModified: number;
              active: boolean;
            };
          }> | null;
        } | null;
      }>;
    };
  } | null;
};

export const RescheduleEventDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RescheduleEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orgId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "externalEventId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "EventTimeType" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateOrDateTime" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timeZone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "offsetMinutes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "millis" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rescheduleEventParent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "orgRelayId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "orgId" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "externalEventId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "externalEventId" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "eventTime" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "type" },
                            value: { kind: "Variable", name: { kind: "Name", value: "type" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "dateOrDateTime" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "dateOrDateTime" },
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "timeZone" },
                            value: { kind: "Variable", name: { kind: "Name", value: "timeZone" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "offsetMinutes" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "offsetMinutes" },
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "millis" },
                            value: { kind: "Variable", name: { kind: "Name", value: "millis" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eventParent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startTime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "millis" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endTime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "millis" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "annotatedEvent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "externalEventId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "orgTags" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "tag" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "state" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "value" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "subjectType" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "subjectValue" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "lastModified" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "active" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "annotatedRecurringEvent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "externalEventId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "orgTags" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "tag" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "state" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "value" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "subjectType" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "subjectValue" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "lastModified" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "active" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<RescheduleEventMutation, RescheduleEventMutationVariables>;
